Page staticPage
	string title
	string content

	show: string id = ""
		string[] segments = Platform.locationHash.split("/")
		let firstSegment = segments[0][1..]
		content = app.getText(firstSegment+"Page")
		title = firstSegment.capitalize
		html.setTitle title + app.titleSuffix

	draw
		div text:content
		html.closeDetails
